import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TemplateList } from '@src/api/responses/TemplatesResponse';

interface TemplatesState {
	value: TemplateList;
	uploadedFile: object | null;
}

const initialState: TemplatesState = {
	value: {},
	uploadedFile: null,
};

const templatesSlice = createSlice({
	name: 'templates',
	initialState,
	reducers: {
		setTemplates: (state, action: PayloadAction<TemplateList>) => {
			state.value = action.payload;
		},
		setUploadedFile: (state, action: PayloadAction<object | null>) => {
			state.uploadedFile = action.payload;
		},
	},
});

export const { setTemplates, setUploadedFile } = templatesSlice.actions;

export default templatesSlice.reducer;
